export const getLoanData = [
  {
    id: 1,
    heading: "How to Get a Personal Loan in 7 Steps",
    subHeading:
      "Securing a personal loan begins with assessing your financial profile and finding the loan offer that best suits your needs.",
    notice:
      "Some of the loan products and financial services featured on this website are provided by our advertising partners. MinEMI may receive compensation when you take certain actions, such as applying for a loan, clicking on a link, or engaging with the offers listed on our site. However, this compensation does not influence our evaluations, recommendations, or the content we provide. Our goal is to help you find the best loan solutions to minimize your EMIs, and our opinions remain unbiased. We are committed to transparency, and below you will find a list of our partners, along with an explanation of how we earn revenue.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
